<template>
    <div class="logo-test">
        <v-toolbar-title style="width: 256px" class="text-center">
            <template v-if="filteredAccountingFirms.length > 1">
                <div @click="dialogChangeAccountingFirm = true" style="cursor: pointer">
                    <div style="height: 30px" v-if="logo">
                        <v-img :src="logo" height="30px" />
                    </div>
                    <div :class="logo ? 'text-truncate text-subtitle-2' : 'text-truncate text-h4'">
                        {{ currentAccountingFirmName }}
                    </div>
                </div>
            </template>
            <template v-else>
                <div style="height: 40px" v-if="logo">
                    <v-img :src="logo" height="40px" />
                </div>
                <div class="text-truncate text-h4" v-else>
                    {{ currentAccountingFirmName }}
                </div>
            </template>
        </v-toolbar-title>
        <oss-dialog
            v-model="dialogChangeAccountingFirm"
            :min-width="!$vuetify.display.mobile ? '650px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            title="Changer de cabinet"
        >
            <div class="pt-3 text-center">
                <v-text-field-filled
                    v-model="searchAccountingFirm"
                    outlined
                    label="Entrez le nom d'un cabinet"
                    autofocus
                    density="compact"
                />
                <v-list style="overflow-y: auto; height: 30vh">
                    <v-list-item
                        v-for="accountingFirm in filteredAccountingFirms"
                        :key="accountingFirm.id"
                        @click="switchAccountingFirm(accountingFirm)"
                        class="mb-2"
                    >
                        <template v-slot:append>
                            <v-icon
                                size="small"
                                color="primary"
                                v-if="accountingFirm.id === currentAccountingFirmId"
                                >$fa-check-circle</v-icon
                            >
                            <v-icon color="grey lighten-1">$chevron_right</v-icon>
                        </template>
                        <v-list-item-title>
                            <span>{{ accountingFirm.name }}</span> </v-list-item-title
                        ><v-list-item-subtitle>
                            <!-- Siret: {{ getSiretValue(accountingFirm.siret) }} -->
                        </v-list-item-subtitle></v-list-item
                    >
                </v-list>
            </div>
        </oss-dialog>
    </div>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import ACCOUNTING_COMPANY_OF_COMPANY from "../../graphql/company/AccountingCompanyOfCompany.gql";
import { getSiretValue } from "../../../src/services/companyServices";
import { updateStoreUserAndSubUser } from "../../../src/services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";

const logoBobbeeMini = require("../../assets/img/bobbee_mini.png");

@Component
export class ossAccountingFirmSelector extends Vue {
    dialogChangeAccountingFirm = false;

    searchAccountingFirm = "";

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get logo() {
        if (
            this.isAccountingUser &&
            this.currentUser &&
            this.currentUser.company &&
            this.currentUser.company.logo &&
            this.currentUser.company.logo.signedUrl
        ) {
            return this.currentUser.company.logo.signedUrl;
        }
        if (
            !this.isAccountingUser &&
            this.accountingFirm &&
            this.accountingFirm.logo &&
            this.accountingFirm.logo.signedUrl
        ) {
            return this.accountingFirm.logo.signedUrl;
        }
        if (
            this.currentUser.isSubUserOf &&
            this.currentUser.isSubUserOf.company &&
            this.currentUser.isSubUserOf.company.logo &&
            this.currentUser.isSubUserOf.company.logo.signedUrl
        ) {
            return this.currentUser.isSubUserOf.company.logo.signedUrl;
        }

        return logoBobbeeMini;
    }

    get filteredAccountingFirms() {
        let filteredAccountingFirms = [];

        if (this.accountingFirms) {
            // On push toutes les accountingFirms du cabinet
            for (const aF of this.accountingFirms) {
                filteredAccountingFirms.push(aF);
            }
        }

        if (this.searchAccountingFirm !== "") {
            return filteredAccountingFirms
                .filter((x) =>
                    x.name.toLowerCase().includes(this.searchAccountingFirm.toLowerCase()),
                )
                .sort((a, b) => a.name.localeCompare(b.name));
        }

        return filteredAccountingFirms.sort((a, b) => a.name.localeCompare(b.name));
    }

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser.id || this.isAccountingUser;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.accountingFirm = data.companies[0];
                }
            }
        },
    })
    accountingFirm = null;

    get accountingFirms() {
        let accountingFirms = [];

        if (this.isAccountingUser) {
            if (this.currentUser.isSubUserOf) {
                if (this.currentUser.isSubUserOf.company?.id) {
                    accountingFirms.push({
                        isSubUser: false,
                        id: this.currentUser.isSubUserOf.company.id,
                        name: this.currentUser.isSubUserOf.company.name,
                        user: this.currentUser.isSubUserOf,
                    });
                } else {
                    debugger;
                }
                if (this.currentUser.isSubUserOf.subUsers?.length) {
                    for (const sU of this.currentUser.isSubUserOf.subUsers) {
                        sU.isSubUserOf = {
                            id: this.currentUser.isSubUserOf.id,
                            firstname: this.currentUser.isSubUserOf.firstname,
                            lastname: this.currentUser.isSubUserOf.lastname,
                        };
                        accountingFirms.push({
                            isSubUser: true,
                            id: sU.company.id,
                            name: sU.company.name,
                            user: sU,
                        });
                    }
                }
            } else if (this.currentUser.subUsers?.length) {
                accountingFirms.push({
                    isSubUser: false,
                    id: this.currentUser.company.id,
                    name: this.currentUser.company.name,
                    user: this.currentUser,
                });

                for (const sU of this.currentUser.subUsers) {
                    sU.isSubUserOf = {
                        id: this.currentUser.id,
                        firstname: this.currentUser.firstname,
                        lastname: this.currentUser.lastname,
                    };
                    accountingFirms.push({
                        isSubUser: true,
                        id: sU.company.id,
                        name: sU.company.name,
                        user: sU,
                    });
                }
            } else {
                accountingFirms.push({
                    isSubUser: false,
                    id: this.currentUser.company.id,
                    name: this.currentUser.company.name,
                    user: this.currentUser,
                });
            }
        } else {
            return this.accountingFirm ? [this.accountingFirm] : [];
        }

        return accountingFirms;
    }

    get currentAccountingFirmName() {
        return this.currentUser?.company?.name ? this.currentUser.company.name : "";
    }

    get currentAccountingFirmId() {
        return this.currentUser?.company?.id ? this.currentUser.company.id : "";
    }

    async switchAccountingFirm(accountingFirm) {
        debugger;

        this.searchAccountingFirm = "";

        if (accountingFirm?.user?.id) {
            if (
                !this.$store.state.user?.id ||
                accountingFirm.user.id !== this.$store.state.user.id
            ) {
                this.$store.commit(
                    "updateSubUserId",
                    accountingFirm.isSubUser ? accountingFirm.user.id : null,
                );
                // this.$store.commit('updateAccountingFirmId', accountingFirm.id)
                await updateStoreUserAndSubUser(this.$apollo, this.$store, accountingFirm.user);
                if (!this.$store.state.inAdmin) {
                    this.$router.push({
                        name: "accountingClients",
                        params: { mode: "production" },
                    });
                } else {
                    // debugger // git-ignore
                    this.$router.push({
                        name: "my-companies-edition",
                        params: { type: "company" },
                    });
                }
            }
        } else {
            debugger; // git-ignore
        }

        this.dialogChangeAccountingFirm = false;
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }
}

export default toNative(ossAccountingFirmSelector);
</script>
